var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKeyIcon = function SvgKeyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.77.727a5.09 5.09 0 0 1 3.87 3.555c.242.815.278 1.677.104 2.51a5.156 5.156 0 0 1-4.991 4.05c-.493 0-.983-.072-1.455-.215l-.9 1.056-.426.197H6.875v1.687l-.562.563H4.625v1.687l-.562.563H.688l-.563-.563v-2.595l.164-.397 5.596-5.596a5 5 0 0 1-.225-1.58A5.094 5.094 0 0 1 11.77.725zm1.483 8.1a4 4 0 0 0 1.393-2.255l.005.005A3.985 3.985 0 0 0 9.935 1.84a4.02 4.02 0 0 0-3.15 3.825 3.8 3.8 0 0 0 .269 1.496l-.124.611-5.68 5.682v1.8H3.5v-1.687l.563-.562H5.75v-1.688l.563-.562h1.4L8.7 9.61l.63-.157c.456.178.94.269 1.428.268a4 4 0 0 0 2.496-.895m-.943-3.073a1.126 1.126 0 1 0-1.824-1.32 1.126 1.126 0 0 0 1.824 1.32",
    clipRule: "evenodd"
  })));
};
export default SvgKeyIcon;